import React from "react";

const Error = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
    >
      <path
        d="M17.5 32.8125C25.9569 32.8125 32.8125 25.9569 32.8125 17.5C32.8125 9.04314 25.9569 2.1875 17.5 2.1875C9.04314 2.1875 2.1875 9.04314 2.1875 17.5C2.1875 25.9569 9.04314 32.8125 17.5 32.8125Z"
        stroke="#EF4C49"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10.9375V17.5"
        stroke="#EF4C49"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 24.0625H17.5146"
        stroke="#EF4C49"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Error;
